import { FlexBox, Icon, SelectionList, Text } from '@dixa/lib-shared-habla';

import { LookupArticle } from './articleLinkLookup';
import s from './articleLinkLookup.module.scss';

export const ArticleItem = ({
  article,
}: {
  article: LookupArticle;
}): JSX.Element => {
  return (
    <SelectionList.Item
      key={article.id}
      contentClassName={s.articleItemContent}
      value={article}
      noFixedSelectionStateSpace
    >
      <Icon name="file-text" className={s.articleItemIcon} />
      <FlexBox flexDirection="column">
        <Text.Paragraph color="secondary" variant="1">
          {article.title}
        </Text.Paragraph>
        <Text.Paragraph color="secondary" variant="4">
          {article.parentCategories?.[0]?.title ?? ''}
        </Text.Paragraph>
      </FlexBox>
    </SelectionList.Item>
  );
};
